import { WorkflowNodeActionRole } from '@app/gen/settings';

import {
  BranchTaskDto,
  NodeActionAttributeDto,
  NodeActionDto,
  StartTaskDto,
  UserTaskDto,
} from '../../dto';

export const FINISH_ACTION_NAME_MAP: Partial<
  Record<NonNullable<NodeActionDto['type']>, string>
> = {
  accept: 'Успешно завершено',
  decline: 'Отклонено',
};

export const TASK_ACTION_NAME_MAP: Partial<
  Record<NonNullable<NodeActionDto['type']>, string>
> = {
  accept: 'Проверка',
  upload: 'Загрузка',
  sign: 'Подписание',
  decline: 'Отклонено',
};

export const OTHER_EXECUTOR_ROLES = ['group', 'manager', 'assistant'] as const;

export const MULTIPLE_ALLOWED_ATTRIBUTE_TYPES: readonly string[] = [
  'choice',
  'text_catalog',
  'year',
] satisfies readonly NodeActionAttributeDto['type'][];

export const ROLE_EXECUTOR_MAP: Record<
  WorkflowNodeActionRole['type'],
  (node: UserTaskDto | BranchTaskDto | StartTaskDto) => WorkflowNodeActionRole[]
> = {
  employee: () => [{ type: 'employee' as const }],

  creator: () => [{ type: 'creator' as const }],

  group: (node) =>
    (node.companyGroup ?? []).map((id) => ({
      type: 'group' as const,
      group: { id, name: ' ' },
    })),

  manager: (node) => [
    {
      type: 'manager' as const,
      manager_type: node.organizationType,
      manager_level: node.hierarchyLevel,
    },
  ],

  assistant: (node) => [
    {
      type: 'assistant' as const,
      assistant_level: node.assistantHierarchyLevel,
    },
  ],
};
